module.exports = __webpack_public_path__ + "static/img/96058D_3_R_20190205_fit.9d9a4e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/96058D_3_R_20190205_fit.png
// module id = jFwA
// module chunks = 0